import { DisabledByDefaultRounded } from "@mui/icons-material";
import { Checkbox, FormControl, FormControlLabel, SxProps, Theme } from "@mui/material";

import { GqlFilterOptionBoolean } from "~/__generated__";

type Props = {
    sx?: SxProps<Theme>;
    option: GqlFilterOptionBoolean;
    value?: boolean | null;
    onChange: (value: boolean | null) => void;
};

export default function BooleanFilter({ sx, option, value, onChange }: Props) {
    const handleClick = () => {
        if (value === false || value === null) {
            onChange(true);
        }

        if (value === true) {
            onChange(null);
        }
    };

    return (
        <FormControl variant="outlined" sx={sx} size="medium">
            <FormControlLabel
                label={option.label}
                control={
                    <Checkbox
                        id={`filter-field-${option.key}`}
                        indeterminate={value === false}
                        indeterminateIcon={<DisabledByDefaultRounded />}
                        checked={value === true}
                        onClick={handleClick}
                    />
                }
            />
        </FormControl>
    );
}
